"use strict";const t=require("react"),n=e=>{t.useEffect(()=>(e&&document.addEventListener("keydown",e),()=>{e&&document.removeEventListener("keydown",e)}),[e])};module.exports=n;
//# sourceMappingURL=useDocumentKeydown.js.map
